var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('div',{staticClass:"question",on:{"click":_vm.select}},[_vm._v(_vm._s(_vm.blok.question))]),_c('div',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.blok.answer.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }